import { defineMessages } from 'react-intl';

export default defineMessages({
  mappingTitle: {
    id: 'LeadListCreate.mappingTitle',
    defaultMessage: 'Map Columns',
  },
});
